import { RouteReuseStrategy, ActivatedRouteSnapshot } from '@angular/router';

export class RouteReuseConfig implements RouteReuseStrategy {
  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    return (
        future.routeConfig === curr.routeConfig &&
        future.params['slug'] === curr.params['slug']
      );
  }

  // Default implementations for the other methods
  shouldDetach(): boolean {
    return false; // No route caching
  }

  store(): void {
    // No caching logic
  }

  shouldAttach(): boolean {
    return false; // No retrieval logic
  }

  retrieve(): null {
    return null; // No stored routes
  }
}
